import {TalentPoolSummaryResponse} from '../features/company/recruiting/talent-pool/types/TalentPoolTypes';
import {GetRoutes} from '../lib/api/GET/GetRoutes';

import {useApiRead} from './useApiRead';

export const TALENT_POOL_SUMMARY_QUERY_KEY = 'talent-pool-summary';

export const useTalentPoolSummary = (companyId: string | undefined) => {
  return useApiRead<TalentPoolSummaryResponse>({
    path: GetRoutes.companyTalentPoolSummary(companyId ?? ''),
    options: {
      enabled: !!companyId,
      queryKey: [TALENT_POOL_SUMMARY_QUERY_KEY, companyId],
    },
  });
};
